@if(ready){<div class="text-medium" [id]="id">
  @if(label && labelPosition === 'left'){<div [class]="'self-center mr-3 font-semibold mb-1 ' + customLabel">
    {{ label }}
    <ng-content select="[labelLeft]"></ng-content>
  </div>}
  @if(label && labelPosition === 'top'){ <div [class]="'self-center font-semibold mb-1 ' + customLabel">
    {{ label }} <ng-content select="[labelTop]"></ng-content>
  </div>}
  <div [class]="
      'select-none relative w-full border-[#D3E0FF] border-[2px] shadow-lg rounded-full font-normal text-[#283759] ' +
      customClassContaier
    ">
    @if(!elementPage){<svg class="absolute right-4 top-[7px] pointer-events-none" [ngClass]="{'rotate-180': expanded}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.47021 10.6396L12.0002 14.1596L15.5302 10.6396" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>}
 @if(elementPage){<svg class="absolute right-2 top-[7px] pointer-events-none" [ngClass]="{'rotate-180': expanded}" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0228 7.14828L9.39779 12.7733C9.34555 12.8256 9.28351 12.8671 9.21523 12.8954C9.14694 12.9237 9.07375 12.9383 8.99982 12.9383C8.9259 12.9383 8.85271 12.9237 8.78442 12.8954C8.71613 12.8671 8.6541 12.8256 8.60186 12.7733L2.97686 7.14828C2.87131 7.04273 2.81201 6.89958 2.81201 6.75031C2.81201 6.60105 2.87131 6.45789 2.97686 6.35234C3.0824 6.2468 3.22556 6.1875 3.37482 6.1875C3.52409 6.1875 3.66725 6.2468 3.77279 6.35234L8.99982 11.5801L14.2269 6.35234C14.2791 6.30008 14.3412 6.25863 14.4094 6.23034C14.4777 6.20206 14.5509 6.1875 14.6248 6.1875C14.6987 6.1875 14.7719 6.20206 14.8402 6.23034C14.9085 6.25863 14.9705 6.30008 15.0228 6.35234C15.0751 6.40461 15.1165 6.46665 15.1448 6.53493C15.1731 6.60322 15.1876 6.6764 15.1876 6.75031C15.1876 6.82422 15.1731 6.89741 15.1448 6.96569C15.1165 7.03398 15.0751 7.09602 15.0228 7.14828Z" fill="#78909C"/>
</svg>
}

    <div [class]="
        'cursor-pointer pl-[15px] text-[#283759] font-semibold text-font14px pr-[36px] py-[7px] text-ellipsis overflow-hidden ' +
        customClassSubContaier
      " (mouseleave)="removeFocus()" (mouseenter)="addFocus()" (click)="changeStatusSelect($event)" [ngClass]="{
        flex: labelPosition === 'left' || labelPosition === 'right'
      }">
      @if(!expanded || !filterable){ <span class="pointer-events-none">{{
        (currentValue && multiple === false) ||
        (multiple === true && currentValue?.length > 0)
        ? pipeTranslationLabelSelect
        ? pipeTranslationLabelSelect(currentValue[bindLabel])
        : currentValue[bindLabel]
        : placeholder
        }}</span>}
      @if(filterable && expanded){ <input (keydown)="filterSearchKey($event)"
        class="border-0 border-transparent w-full text-[#719CFF] outline-none" [placeholder]="filterLabel"
        (click)="$event.stopPropagation()" [(ngModel)]="filterSearch" [id]="'select-filter-input-' + id" />}
      @if(multiple && showMultipleSelection && (!expanded || !filterable)){ <div class="flex flex-wrap gap-2">
        <span [title]="pipeTranslationLabelSelect
          ? pipeTranslationLabelSelect(item[bindLabel])
          : item[bindLabel]" *ngFor="let item of currentValue; let last = last; let index = index" [class]="
            'bg-primary rounded-lg uppercase whitespace-nowrap text-ellipsis overflow-hidden max-w-[200px] text-small flex place-content-center items-center text-white p-2 ' +
            customPillClass
          "><span class="max-w-[180px]  whitespace-nowrap text-ellipsis overflow-hidden">{{
            pipeTranslationLabelSelect
            ? pipeTranslationLabelSelect(item[bindLabel])
            : item[bindLabel]
            }}</span>
          @if(iconClose){
          <img (click)="$event.stopPropagation(); removeItem(index)" [class]="'ml-1 ' + customClassClose"
            [src]="iconClose" />}
          <span (click)="$event.stopPropagation(); removeItem(index)"><ng-content
              select="[iconClose]"></ng-content></span>
        </span>
      </div>}
      @if(multiple && this.currentValue?.length && !showMultipleSelection && (!expanded || !filterable)){
        {{placeholder}} <span class="text-[#F15928] ml-3">{{this.currentValue?.length ? '(' + this.currentValue?.length + ')' : ''}}</span>
      }
      @if( multiple &&
      showNumberSelected &&
      currentValue?.length > 0 &&
      (!expanded || !filterable)){ <div>
        {{
        currentValue?.length +
        (currentValue?.length === 1
        ? labelOneElementSelected
        : labelElementSelected)
        }}
      </div>}
    </div>
    @if(expanded){
    <div class="overflow-visible pt-[5px] z-[1] absolute w-full">

      <div style="box-shadow: 2px 4px 12px 0px #0000001a" [class]="
        'bg-white rounded-lg mt-[0px] w-full min-h-[75px] ' +
        customClassContainerElement
      " [id]="'container-options-' + id" (scroll)="scrollData($event)"
        [ngClass]="{ 'bottom-full mb-[5px] mt-[0px]': direction === 'up' }">
        @if((useDataInfiniteScroll? getFilteredData().slice(limitBefore,limitAfter) : getFilteredData())?.length == 0){
        <div class="text-medium text-black font-semibold text-center w-full">NO DATA</div>
        }
        <div [id]="'select-id-' + item[bindValue]" (click)="$event.stopPropagation();addElement(item)"
          class="flex cursor-pointer py-[7.5px] pl-[7.5px] items-center whitespace-nowrap text-ellipsis overflow-hidden w-full"
          *ngFor="let item of useDataInfiniteScroll? getFilteredData().slice(limitBefore,limitAfter) : getFilteredData() ; let last = last;let first = first"
          [ngClass]="{ '!pb-[15px]': last ,'!pt-[15px]': first, '!pl-1.5':elementPage }">
          @if(multiple && showCheck){ <div class="pointer-events-none">
            <std-checkbox borderTrue="#719CFF" backGroundTrue="#445E99" width="20px" height="20px"
              [isChecked]="controlCheck(item[bindValue])" type="circle" size="sm"></std-checkbox>
          </div>}
          <span [title]="
                pipeTranslationLabelSelect
                ? pipeTranslationLabelSelect(item[bindLabel])
                : item[bindLabel]
                "
                [ngClass]="{'fix-element-page min-w-[50px]': elementPage}"
            class="w-[calc(100%-40px)] text-[#283759] font-semibold text-font14px whitespace-nowrap text-ellipsis overflow-hidden">{{
            pipeTranslationLabelSelect
            ? pipeTranslationLabelSelect(item[bindLabel])
            : item[bindLabel]
            }}</span>
          
        </div>
      </div>
    </div>
    }
  </div>
  @if(label && labelPosition === 'right'){<div [class]="'self-center ml-3 font-semibold mb-1 ' + customLabel">
    {{ label }} <ng-content select="[labelRight]"></ng-content>
  </div>}
  @if(label && labelPosition === 'bottom'){<div [class]="'self-center mt-2 font-semibold mb-1 ' + customLabel">
    {{ label }} <ng-content select="[labelBottom]"></ng-content>
  </div>}
</div>}